module.exports = __webpack_public_path__ + "static/img/page_not_found.0a25c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/page_not_found.png
// module id = Lpn3
// module chunks = 31